import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/auth.scss';
import './styles/common.scss';
import './styles/mui.scss';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
// Mute console outputs in UAT environment
if (process.env.REACT_APP_ENV === 'uat') {
  const noop = () => {};
  console.debug = noop;
  console.log = noop;
  console.info = noop;
  console.warn = noop;
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>
  // </React.StrictMode>
);
